module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Editor di tag","addTag":"Aggiungi tag","addTags":"Aggiungi tag","noTags":"Non sono presenti tag per questo elemento","tagName":"Nome tag"},"en":{"noTags":"No tags for this item"}}')
  delete Component.options._Ctor
}
